// components/shared/Pagination/PaginationBar.tsx
import Pagination, { IPagination } from "./Pagination";

type IPaginationBar = IPagination & { total: number; pageSize?: number };

export default function PaginationBar({
  currentPage,
  totalPages,
  onPageChange,
  total,
  pageSize = 10,
}: IPaginationBar) {
  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, total);

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mt-4">
      <span className="text-muted small">
        Showing <strong>{start}</strong> – <strong>{end}</strong> of{" "}
        <strong>{total}</strong>
      </span>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </div>
  );
}
